import React, { FC, useEffect, useRef, useState } from "react";
import { Avatar, Spin } from "antd";
import Card, { CardHeader, CardBody } from "@components/card";

import './alerts.scss';
import { TAlertsCardProps } from "../constant";
// import moment from "moment";
import membersService from "@services/members.service";
import CheckCircle from "@assets/check-circle.svg";
import CheckFillCircle from "@assets/check-fill-circle.svg";
import { changeDateFormatinDescription, formatDisplayDate } from "@utils/helpers";
import HealthemSpinner from "@components/healthemSpinner/healthemSpinner";

const NotesCard: FC<TAlertsCardProps> = ({ className, width, avatarSize, alertReadStatusHandler, data, onShowMore, tab }: TAlertsCardProps) => {
  const { patientName, alert, alertDate, alertReadStatus, alertId } = data ?? {};
  // const [showMoreBtn, showMoreHandler] = useState(false);
  const [alertSeenLoader, setAlertSeenLoader] = useState(false);
  const charLength = 80;

  const markReadHandler = () => {
    setAlertSeenLoader(true)
    membersService.updateAlert(alertId).subscribe({
      next: (res) => {
        // let response = res?.data?.data?.alerts;
        alertReadStatusHandler(data)
        setAlertSeenLoader(false)
      },
      error: (err) => {
        setAlertSeenLoader(false)
      },
    });

  }

  // const showMore = () => {
  //     showMoreHandler(true);
  // };
  const content = useRef<HTMLDivElement>(null)

  const toggleShowMore = () => {
    if (content.current) {
      content.current.scrollTop = 0
    }
    // showMore(showMoreBtn ? false : true)
    onShowMore(data.isShowMore ? false : true)
  }

  const [contentHeight, setContentHeight] = useState(0)

  useEffect(
    () => {
      setTimeout(
        () => {
          setContentHeight(content.current?.scrollHeight || 0)
        },
        50
      )
    },
    [alert]
  )


  const getContentView = () => {
    const alertItem: any = <div dangerouslySetInnerHTML={{ __html: alert }}></div>;
    return (
      <>
        <div className={`alertsContent alerts-transition custom-scroll-bar alerts-html ${data.isShowMore ? 'more' : 'less'}`} ref={content}>
          {alertItem}
        </div>
        {
          contentHeight > 40 &&
          <div className="alertsContent__showMoreLink" onClick={() => toggleShowMore()}>
            {data.isShowMore ? 'less' : 'more'}
          </div>
        }
      </>
      // <p className="noteContent" style={{maxHeight: '77px'}}>
      //     <span>{changeDateFormatinDescription(alert)?.substring(0, charLength-1)}</span>
      //     <span className="link showMoreLink clr-blueLink" onClick={showMore}>...more</span>
      // </p>
    );
  }

  return (
    <Card className={`${className} alert ${data.isShowMore ? 'showmore' : 'showless'}`} id={`drawer_alert_card_${tab}_${alertId}`} width={width}>
      <CardHeader className="alertsCardHeader f14">
        {/* <Avatar className="card-avatar">{patientName?.charAt(0)}</Avatar> */}
        <span className="clr-blueLink w500">{patientName}</span>
      </CardHeader>
      <CardBody className="alertsCardBody">
        <div className="markSeenAlert">
          <span className="italic f10 clr-lightGrayColor">{formatDisplayDate(alertDate, 'reminderDateActualFormat', 'defaultDateFormatWithTimeWithPipe', true)}</span>
          {alertReadStatus === 'Y' ? (
            <>
              <span><img
                src={CheckFillCircle}
                className="marked-icon f18"
                alt="check-circle"
              />
                <span className="marked-label f18">Seen</span>
              </span>
            </>
          ) : (
            <Spin spinning={alertSeenLoader} size="small" indicator={<HealthemSpinner />}>
              <div className="mark-seen-alert" onClick={() => markReadHandler()} >
                <img
                  src={CheckCircle}
                  className="marked-icon f18"
                  alt="check-circle"
                />
                <span className="marked-label f18"
                >
                  Mark Seen
                </span>
              </div>
            </Spin>
          )}
        </div>
        {getContentView()}
      </CardBody>
    </Card>
  );
};

export default NotesCard;
